import numeral from "numeral"

export const formatDollars = (amount = 0) => numeral(amount).format("$0,0.00")
export const centsToDollars = (cents = 0) => formatDollars(cents / 100)
